import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowRight, ChevronLeft, MapPin } from "lucide-react";
import PageHero from "../components/PageHero";
import FadeIn from "../components/FadeIn";
import { CATEGORIES } from "../mock";
import CallbackDialog from "../components/CallbackDialog";
import useSEO from "../hooks/useSEO";

const CategoryDetail = () => {
  const { slug } = useParams();
  const category = CATEGORIES.find((c) => c.slug === slug);
  useSEO({
    title: category ? category.name : "Catalog",
    description: category ? category.description : "Prime Trade commodity catalog.",
  });

  if (!category) return <Navigate to="/catalog" replace />;

  return (
    <main>
      <PageHero
        title={category.name}
        eyebrow="Catalog"
        breadcrumbs={[{ label: "Products", path: "/catalog" }, { label: category.name }]}
      />

      <section className="pt-section">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <FadeIn className="lg:col-span-6">
              <img src={category.image} alt={category.name} className="w-full h-[420px] object-cover" />
            </FadeIn>
            <FadeIn className="lg:col-span-6" delay={120}>
              <div className="pt-eyebrow">Overview</div>
              <h2 className="pt-h2">{category.name}</h2>
              <div className="pt-divider" />
              <p className="text-[15px] leading-relaxed text-[#4a4a4a] mb-6">{category.description}</p>
              <div className="flex flex-wrap gap-3">
                <CallbackDialog>
                  <button className="btn-red">Request a quote <ArrowRight size={14} /></button>
                </CallbackDialog>
                <Link to="/catalog" className="btn-outline"><ChevronLeft size={14} /> Back to products</Link>
              </div>
            </FadeIn>
          </div>

          <div className="mt-20">
            <FadeIn>
              <div className="flex items-end justify-between gap-4 mb-8">
                <div>
                  <div className="pt-eyebrow">Products</div>
                  <h3 className="pt-h2" style={{ fontSize: 32 }}>Available items</h3>
                  <div className="pt-divider" />
                </div>
                <div className="text-sm text-[#7a7a7a]">{category.products.length} products</div>
              </div>
            </FadeIn>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {category.products.map((p, i) => (
                <FadeIn key={p.name} delay={i * 60}>
                  <div className="pt-cat-card h-full">
                    <div className="img-wrap" style={{ height: 200 }}>
                      <img src={p.image} alt={p.name} />
                    </div>
                    <div className="p-5">
                      <h4 className="text-[18px] font-semibold text-[#2c2c2c] mb-2 leading-tight">{p.name}</h4>
                      <div className="flex items-start gap-2 text-[13px] text-[#7a7a7a]">
                        <MapPin size={14} className="text-[#e30613] mt-0.5 shrink-0" />
                        <span>{p.origin}</span>
                      </div>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CategoryDetail;
